import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwitchToOld = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 20,
	viewBox: "0 0 24 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.9587 1H20.3337C20.8862 1 21.4161 1.21071 21.8068 1.58579C22.1975 1.96086 22.417 2.46957 22.417 3V13C22.417 13.5304 22.1975 14.0391 21.8068 14.4142C21.4161 14.7893 20.8862 15 20.3337 15H3.66699C3.11446 15 2.58455 14.7893 2.19385 14.4142C1.80315 14.0391 1.58366 13.5304 1.58366 13V10M16.167 19H7.83366M12.0003 15V19M6.79199 6L1.58366 1M1.58366 1H6.79199M1.58366 1V6",
		stroke: "#A18EF2",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgSwitchToOld);
export { ForwardRef as ReactComponent };
